export default __webpack_public_path__ + "304d1599fdb57bc3bef554945c5b7420.png";